export default {"theme":{"light":true,"themes":{"light":{"fhGray":"F5F5F5","primary":"#005096","accent":"#424242","secondary":"#407bb3","info":"#26a69a","warning":"#ffc107","error":"994040","success":"#00e676","dark":"#343a40"}}}}
